 
export default class   PhotoBeneficiarioResponse {
    constructor(public success?: boolean,
        public message?: string,
        public respCode?: number,
        public base64String?: string
    ){}
}

 

export {PhotoBeneficiarioResponse}